<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header'>Depot Stock Locations</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/workshop/depot-stock-locations/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    </div>
  </div>
  <br />
  <br />
  <app-grid
    entity='depot-stock-location'
    [columns]='this.columns'
    [buttons]='this.buttons'
  ></app-grid>
</div>
